import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {CardContent} from 'views/components';
import {Typography, Stack, Box, IconButton, Menu, MenuItem} from 'views/components';
import {MoreVert as MoreVertIcon} from 'views/icons';
import {Translate, translate, useNavigate} from 'views/module';

const Card = (props) => {
  const item = props.item;
  const userRn = item.userRn;
  const firstName = item.firstName;
  const lastName = item.lastName;
  const status = item.status;
  const email = item.email;
  const role = item.role;

  const navigate = useNavigate();

  // State to manage the menu open/close
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    navigate(`/admin/user/${userRn}/deactivate`);
  };

  return (
    <React.Fragment>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h5" >
              {firstName} {lastName}
            </Typography>
            <Typography sx={{fontSize: 14}}>
              <Translate
                expression={`user.UserList.Card.Email`}
                substitute={{email}}
              />
            </Typography>
            <Typography sx={{fontSize: 14}}>
              <Translate
                expression={`user.UserList.Card.UserStatus`}
                substitute={{status: translate(`user.UserList.Card.Status.${status}`)}}
              />
            </Typography>
            <Typography sx={{fontSize: 14}}>
              <Translate
                expression={`user.UserList.Card.Role`}
                substitute={{status: translate(`user.UserList.Card.RoleOptions.${role}`)}}
              />
            </Typography>
          </Box>
          <IconButton onClick={handleClick}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <MenuItem onClick={handleDelete}>
              <Translate expression={`user.UserList.Card.Action.Deactivate`} />
            </MenuItem>
          </Menu>
        </Stack>
      </CardContent>
    </React.Fragment>
  );
};

Card.propTypes = {
  item: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, dispatch)(React.memo(Card));
